export default __webpack_public_path__ + "static/media/landing-Word-Objeto5.26e89105.webp";